import React from "react";
import { Navigate } from "react-router-dom";
import { obtenerPrimerAccesoPermitido } from "./firstAllowedRoute.utils";

const FirstAllowedRoute: React.FC = () => {
  const destino = obtenerPrimerAccesoPermitido() ?? "/login";
  return <Navigate to={destino} replace />;
};

export default FirstAllowedRoute;
